import React from 'react';
import { getTranslations } from '../../translations';
import { ColourSet } from './ColourSet';
import useFiltersQuery from '../../api/use-filters-query';
import { ResponseSelector } from '../../types/globalapi/response-selector';
import { ColourFilterOption, FiltersResponse } from '../../types/globalapi/filters';

export const ExteriorSelect = () => {
  const { labels } = getTranslations();

  const getExteriorOptions: ResponseSelector<FiltersResponse, ColourFilterOption[]> = res => res.color_exterior;

  const { data: exteriors } = useFiltersQuery<FiltersResponse, ColourFilterOption[]>({select: getExteriorOptions});

  return (
    exteriors
    ? <ColourSet
      id="exterior"
      label={labels.exterior}
      type="color_exterior"
      list={exteriors as ColourFilterOption[]}
    />
    : null
  );
};
